import { TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";

export default function Step01() {

    const { control, getFieldState } = useFormContext();

    return (
        <>
            <Controller
                name="separador"
                control={control}
                rules={{ required: 'Campo obrigatório' }}
                render={({ field }) => (
                    <TextField
                        {...field}
                        label="Separador"
                        variant="outlined"
                        required
                        fullWidth
                        margin="normal"
                        error={getFieldState('separador').invalid}
                        helperText={getFieldState('separador').error?.message || ""}
                    />
                )}
            />
        </>
    )
}